import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { environment } from 'environments/environment';
import { AnalyticsEventDirectiveModule } from 'idt-analytics-api/directives/analytics-events-directive.module';
import { RenderLinksEventsDirective } from 'render/directives/render-links-events.directive';
import { RenderEventsModule } from 'render/render-events/render-events.module';
import { CommonStylesRenderComponent } from 'render/render-shared/common-styles-render/common-styles-render.component';
import { IdtSharedRenderService } from 'render/render-shared/idt-shared-render.service';
import { RenderModalPanelComponent } from 'render/render-shared/ui/render-modal-panel/render-modal-panel.component';
import { renderModalPanelReducer } from 'render/render-shared/ui/render-modal-panel/store/render-modal-panel.reducer';
import { RenderByDeviceService } from 'render/services/base-render-by-device/render-by-device.service';
import { CookieService } from 'render/services/render-cookies.service';
import { SharedConfigurationService } from 'shared/services/shared-configuration.service';
import { SharedModule } from 'shared/shared.module';

import { RenderLinkComponent } from './render-link/render-link.component';
import { RenderWysiwygComponent } from './render-wysiwyg/render-wysiwig.component';
import { RenderButtonComponent } from './ui/render-button/render-button.component';
import { RenderSelectOptionComponent } from './ui/render-select/render-select-option/render-select-option.component';
import { RenderSelectComponent } from './ui/render-select/render-select.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('renderModalPanel', renderModalPanelReducer),
    RouterModule,
    A11yModule,
    RenderEventsModule,
    AnalyticsEventDirectiveModule,
    MatIconModule
  ],
  declarations: [
    RenderWysiwygComponent,
    RenderLinkComponent,
    RenderButtonComponent,
    RenderSelectComponent,
    RenderSelectOptionComponent,
    RenderModalPanelComponent,
    RenderLinksEventsDirective,
    CommonStylesRenderComponent
  ],
  exports: [
    RenderWysiwygComponent,
    RenderLinkComponent,
    RenderSelectComponent,
    RenderSelectOptionComponent,
    RenderButtonComponent,
    RenderModalPanelComponent,
    RenderLinksEventsDirective,
    CommonStylesRenderComponent,
    RenderEventsModule,
    SharedModule,
    MatIconModule
  ],
  providers: [
    CookieService,
    RenderByDeviceService,
    IdtSharedRenderService
  ]
})
export class RenderSharedModule {

  constructor(
    private readonly sharedConfigurationService: SharedConfigurationService
  ) {
    this.sharedConfigurationService.config = environment;
  }

}
